/* eslint-disable promise/always-return */
/* eslint-disable no-console */
import { forEach } from 'lodash';
import $ from 'jquery';
import { x } from '../_helpers';
import LazyLoadService from '../_utilities/lazy-module-service';
import MatchLiveUpdate from './match-live-update';
import {
  dashedActiveClassName,
  hiddenClassName,
  customResizeEvent,
  animationSpeed,
  dataLoadStartEvent,
  matchCardLiveHook,
  localTimeHook,
} from '../_helpers/constants';
import LocalTime from './local-time';

export default class TournamentDraws {
  constructor() {
    this.tournamentDraws = $('[js-tournament-draws]')[0];
    this.panelDraws = $('[js-draw-panel]')[0];
    this.selectorIdentifier = 'js-draw-panel-selector';
    this.selectorAttr = '[js-draw-panel-selector]';
    this.panelRoundAttr = '[js-draw-panel-round]';
    this.tournamentDrawsPanelAttr = '[js-draw-panel]';
    this.tournamentDrawsRoundsAttr = '[js-draw-rounds]';
    this.tournamentDrawsRoundsWrapperAttr = '[js-draw-rounds-wrapper]';
    this.roundsAttr = '[js-draw-rounds]';
    this.roundAttr = '[js-draw-round]';
    this.matchesAttr = '[js-draw-matches]';
    this.filterEventIdentifier = 'js-draw-filter-event';
    this.filterEventAttr = '[js-draw-filter-event]';
    this.filterYearIdentifier = 'js-draw-filter-year';
    this.filterYearAttr = '[js-draw-filter-year]';
    this.spinnerContainerAttr = '[js-spinner-container]';
    this.errorMessageAttr = '[js-error-message]';
    this.matchTopMargin = 120;
    this.roundLeftMargin = 5;
    this.mobileZoom = 0.4;
    this.tabletSize = 768;
    this.activeRound = this.tournamentDraws.dataset.activeRound;

    this.service = new LazyLoadService();
    this.matchLiveUpdate = new MatchLiveUpdate();

    this.localTime = new LocalTime();
    this.localItems = [];

    this.focusOnActiveRound();
  }

  focusOnActiveRound() {
    const panelRounds = this.tournamentDraws.querySelectorAll(this.panelRoundAttr);
    forEach(panelRounds, (panelRound) => {
      if (panelRound.dataset.roundSlug === this.activeRound) {
        const panelSelector = panelRound.querySelectorAll(this.selectorAttr)[0];
        this.moveToMatch(panelSelector);
      }
    });
  }

  moveToMatch(selector) {
    //change active class
    const allSelectors = this.panelDraws.querySelectorAll(this.selectorAttr);
    forEach(allSelectors, function (element) {
      element.classList.remove(dashedActiveClassName);
    });
    selector.classList.add(dashedActiveClassName);

    const selectorDataset = selector.dataset;
    const roundsContainer = $(this.roundsAttr);
    const roundSelector = `${this.roundAttr}:nth-child(${selectorDataset.roundIndex})`;
    const roundContainer = $(roundSelector);
    let roundContainerLeft = roundContainer.position().left;
    if (window.innerWidth < this.tabletSize) {
      roundContainerLeft = roundContainerLeft / this.mobileZoom;
    }
    //round move animation
    roundsContainer.animate(
      {
        scrollLeft: roundContainerLeft + roundsContainer.scrollLeft() + this.roundLeftMargin,
      },
      animationSpeed
    );

    const matchesContainer = roundContainer.find(this.matchesAttr);
    const matchesNumber = matchesContainer.children().length;
    const matchesPerGroup = matchesNumber / selectorDataset.matchesGroups;
    const matchIndex = 0 + (selectorDataset.matchesIndex - 1) * matchesPerGroup;
    const matchItem = matchesContainer.children()[matchIndex];
    //match move animation
    const matchElTopDist = window.pageYOffset + matchItem.getBoundingClientRect().top;
    const scrollTopDist = matchElTopDist - this.matchTopMargin;
    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
      window.scrollTo(0, scrollTopDist);
    } else {
      $('html, body').animate(
        {
          scrollTop: scrollTopDist,
        },
        animationSpeed
      );
    }
  }

  _updateDataJsonAttributes(plugin, eventId, season) {
    $.extend(true, plugin.JSON, {
      Module: {
        EventId: eventId,
        Season: season,
        IsLazyLoadCall: true,
      },
    });

    plugin.$target.attr('data-json-module', JSON.stringify(plugin.JSON));
  }

  async loadNewContent() {
    const eventValue = $(this.filterEventAttr).val();
    const yearValue = $(this.filterYearAttr).val();
    const spinner = $(this.spinnerContainerAttr);

    const plugin = {};
    plugin.$target = $(this.tournamentDraws);
    const dataJson = plugin.$target.attr('data-json-module');
    plugin.JSON = JSON.parse(dataJson);
    this._updateDataJsonAttributes(plugin, eventValue, yearValue);

    spinner.removeClass(hiddenClassName);
    window.dispatchEvent(new CustomEvent(dataLoadStartEvent));
    await this.service
      .initByElement(false, plugin.$target, true, false, false, false, true)
      .then((data) => {
        if (!data) {
          this.removeSpinner();
          this.showErrorMessage();
        } else {
          this.setPolling();
          this.toLocalTime();
          this.setCardsContainerHeight();
        }
      })
      .catch((error) => {
        this.showErrorMessage();
        this.removeSpinner();
        console.warn(error);
      });
  }

  removeSpinner() {
    const spinner = $(this.spinnerContainerAttr);
    spinner.addClass(hiddenClassName);
  }

  showErrorMessage() {
    const message = $(this.errorMessageAttr);
    message.removeClass(hiddenClassName);
    $(this.tournamentDrawsPanelAttr).addClass(hiddenClassName);
    $(this.tournamentDrawsRoundsAttr).addClass(hiddenClassName);
  }

  setCardsContainerHeight() {
    if (window.innerWidth < this.tabletSize) {
      const roundHeight = $(this.tournamentDrawsRoundsAttr).height() * this.mobileZoom;
      $(this.tournamentDrawsRoundsWrapperAttr).height(roundHeight);
    } else {
      $(this.tournamentDrawsRoundsWrapperAttr).height('auto');
    }
  }

  setPolling() {
    this.liveItems = x(matchCardLiveHook);
    if (this.liveItems) {
      this.matchLiveUpdate.initItems();
    }
  }

  setEventListners() {
    const self = this;
    this.tournamentDraws.addEventListener('click', function (e) {
      if (e.target.hasAttribute(self.selectorIdentifier)) {
        self.moveToMatch.bind(self)(e.target);
      } else if (e.target.parentElement.hasAttribute(self.selectorIdentifier)) {
        self.moveToMatch.bind(self)(e.target.parentElement);
      }
    });

    this.tournamentDraws.addEventListener('change', async function (e) {
      if (
        e.target.hasAttribute(self.filterEventIdentifier) ||
        e.target.hasAttribute(self.filterYearIdentifier)
      ) {
        await self.loadNewContent.bind(self)();
      }
    });

    window.addEventListener(customResizeEvent, () => {
      this.setCardsContainerHeight();
    });
  }

  toLocalTime() {
    this.localItems = x(localTimeHook);
    this.localTime.initItems(this.localItems);
  }

  init() {
    this.setEventListners();
    this.setCardsContainerHeight();
  }
}
